import { render, staticRenderFns } from "./volunteerRecord.vue?vue&type=template&id=2da388ac&"
import script from "./volunteerRecord.vue?vue&type=script&lang=js&"
export * from "./volunteerRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports